export default "__VITE_ASSET__CpuYCFmp__"